import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { MAP_CONSTANTS } from "../constants/mapConstants";

const ComponentSelectionForm = ({
  selectionType,
  onSelectionTypeChange,
  selectedComponent,
  onComponentChange,
  selectedRadius,
  onRadiusChange,
  myComponents,
  t,
}) => {
  return (
    <>
      {/* Radio buttons with space-around instead of space-between */}
      <FormControl
        component="fieldset"
        sx={{
          mb: 2,
          width: "100%",
        }}
      >
        <RadioGroup
          row
          aria-label="selection-type"
          name="selection-type"
          value={selectionType}
          onChange={onSelectionTypeChange}
          sx={{ justifyContent: "space-around" }}
        >
          <FormControlLabel
            value="themes"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#5f6368",
                  "&.Mui-checked": { color: "#d3af5f" },
                }}
              />
            }
            label={t("mapWithComponents.radioThemes")}
          />
          <FormControlLabel
            value="objects"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#5f6368",
                  "&.Mui-checked": { color: "#d3af5f" },
                }}
              />
            }
            label={t("mapWithComponents.radioObjects")}
          />
        </RadioGroup>
      </FormControl>

      {/* Component selection dropdown with visible border and better dropdown styling */}
      <FormControl fullWidth variant="outlined" size="small" sx={{ mb: 2 }}>
        <Select
          value={selectedComponent}
          onChange={onComponentChange}
          displayEmpty
          sx={{
            boxSizing: "unset",
            height: "40px",
            "& .MuiSelect-select": {
              color: "#333333",
              fontWeight: 500,
              paddingLeft: "10px",
            },
            border: "1px solid rgba(51,51,51, 0.2)",
            borderRadius: "4px",
            "&:hover": {
              borderColor: "#d3af5f",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&.Mui-focused": {
              borderColor: "#d3af5f",
              borderWidth: "2px",
              boxShadow: "0 0 0 1px rgba(211, 175, 95, 0.25)",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: "#ffffff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                "& .MuiMenuItem-root": {
                  color: "#333333",
                  padding: "8px 16px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(211, 175, 95, 0.15)",
                    "&:hover": {
                      backgroundColor: "rgba(211, 175, 95, 0.25)",
                    },
                  },
                },
              },
            },
          }}
        >
          <MenuItem disabled value="">
            <em style={{ color: "#555555" }}>
              {selectionType === "themes"
                ? t("mapWithComponents.menuItemThemePlaceholder")
                : t("mapWithComponents.menuItemObjectPlaceholder")}
            </em>
          </MenuItem>
          {myComponents[selectionType].map((cmp) => (
            <MenuItem key={cmp._id} value={cmp._id}>
              {cmp[selectionType === "themes" ? "title" : "name"]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Radius input with more visible styling */}
      {selectionType === "themes" && (
        <TextField
          label={t("mapWithComponents.radiusInput")}
          type="number"
          fullWidth
          value={selectedRadius}
          onChange={onRadiusChange}
          size="small"
          inputProps={{
            min: MAP_CONSTANTS.MIN_RADIUS,
            max: 1000,
            style: {
              color: "#333333",
              fontWeight: 500,
            },
          }}
          variant="outlined"
          sx={{
            mb: 1,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#d3d3d3",
              },
              "&:hover fieldset": {
                borderColor: "#b0b0b0",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#d3af5f",
                borderWidth: "2px",
              },
            },
            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
              {
                WebkitAppearance: "none",
                margin: 0,
              },
            "& input[type=number]": {
              MozAppearance: "textfield",
            },
          }}
        />
      )}
    </>
  );
};

export default ComponentSelectionForm;
